import Stack from '@mui/material/Stack';

export const UnreadIndicator = () => (
  <Stack
    data-testid="unread-notification-indicator"
    sx={{
      width: '8px',
      height: '8px',
      backgroundColor: 'secondary.main',
      borderRadius: '50%',
      flexShrink: 0,
    }}
  />
);
